/**
 * Electrical Panel Customizer
 * كل الـ selectors بتدور جوه [data-epc] بس، عشان لو السكشن اتكرر
 * أكتر من مرة في نفس الصفحة كل نسخة تشتغل لوحدها.
 */
(function () {
  'use strict';
  var EN = window.PortafotoLang === 'en';
  var COPY = EN ? {
    currency: 'EGP',
    upload: 'Upload artwork',
    choosePreview: 'Choose a size and frame colour to preview',
    chooseFirst: 'Choose a size and frame colour first.'
  } : {
    currency: 'ج.م',
    upload: 'ارفع تصميمك',
    choosePreview: 'اختار المقاس واللون للمعاينة',
    chooseFirst: 'اختار المقاس ولون الفريم الأول.'
  };

  function moneyFormat(cents, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.money_format) {
      return window.Shopify.formatMoney(cents, window.money_format);
    }
    var value = (cents / 100).toLocaleString(EN ? 'en-EG' : 'ar-EG');
    return value + ' ' + (currency || COPY.currency);
  }

  function initCustomizer(root) {
    var sizeButtons = root.querySelectorAll('[data-epc-sizes] .epc-option-btn');
    var colorButtons = root.querySelectorAll('[data-epc-colors] .epc-swatch');
    var directionButtons = root.querySelectorAll('.epc-direction-btn');

    var variantInput = root.querySelector('[data-epc-variant-input]');
    var sizeInput = root.querySelector('[data-epc-size-input]');
    var colorInput = root.querySelector('[data-epc-color-input]');
    var directionInput = root.querySelector('[data-epc-direction-input]');

    var priceEls = root.querySelectorAll('[data-epc-price]');
    var totalPriceEl = root.querySelector('[data-epc-total-price]');
    var submitBtn = root.querySelector('[data-epc-submit]');
    var errorEl = root.querySelector('[data-epc-error]');
    var form = root.querySelector('[data-epc-form]');

    var fileInput = root.querySelector('[data-epc-file-input]');
    var uploadLabel = root.querySelector('[data-epc-upload]');
    var uploadText = root.querySelector('[data-epc-upload-text]');
    var uploadTrigger = root.querySelector('[data-epc-upload-trigger]');

    var frame = root.querySelector('[data-epc-frame]');
    var door = root.querySelector('[data-epc-door]');
    var previewImg = root.querySelector('[data-epc-preview-img]');
    var placeholder = root.querySelector('[data-epc-placeholder]');
    var previewCaption = root.querySelector('[data-epc-preview-caption]');
    var previewToggle = root.querySelector('[data-epc-preview-toggle]');
    var revealInput = root.querySelector('[data-epc-reveal]');
    var wall = root.querySelector('.epc-wall');

    var state = {
      variantId: null,
      sizeLabel: null,
      priceCents: null,
      colorValue: null,
      colorLabel: null,
      direction: 'فتح يمين',
      hasFile: false
    };

    function updateCaption() {
      if (!previewCaption) return;
      var parts = [];
      if (state.sizeLabel) parts.push(state.sizeLabel);
      if (state.colorLabel) parts.push(state.colorLabel);
      previewCaption.textContent = parts.length ? parts.join(' — ') : COPY.choosePreview;
    }

    function updateSubmitState() {
      var ready = state.variantId && state.colorValue;
      submitBtn.disabled = !ready;
    }

    function selectSize(btn) {
      sizeButtons.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');

      state.variantId = btn.getAttribute('data-variant-id');
      state.priceCents = parseInt(btn.getAttribute('data-price'), 10);
      state.sizeLabel = btn.childNodes[0].textContent.trim();

      variantInput.value = state.variantId;
      sizeInput.value = state.sizeLabel;

      var formatted = moneyFormat(state.priceCents);
      priceEls.forEach(function (el) { el.textContent = formatted; });
      if (totalPriceEl) totalPriceEl.textContent = formatted;

      updateCaption();
      updateSubmitState();
      root.dispatchEvent(new CustomEvent('epc:selectionchange'));
    }

    function selectColor(btn) {
      colorButtons.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');

      state.colorValue = btn.getAttribute('data-color-value');
      state.colorLabel = btn.getAttribute('data-color-label');
      colorInput.value = state.colorLabel;

      if (frame) {
        frame.style.setProperty('--frame-color', state.colorValue);
        var textureMap = {
          'أسود': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-black.png?v=1787848377')",
          'أبيض': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-white.png?v=1787848384')",
          'خشبي فاتح': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-light-wood.png?v=1787848407')",
          'خشبي غامق': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-dark-wood.png?v=1787848394')",
          'دهبي': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-gold.png?v=1787848369')",
          'Black': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-black.png?v=1787848377')",
          'White': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-white.png?v=1787848384')",
          'Light wood': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-light-wood.png?v=1787848407')",
          'Dark wood': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-dark-wood.png?v=1787848394')",
          'Gold': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-gold.png?v=1787848369')"
        };
        frame.style.setProperty('--frame-texture', textureMap[state.colorLabel] || 'none');
      }

      updateCaption();
      updateSubmitState();
    }

    function selectDirection(btn) {
      directionButtons.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');

      state.direction = btn.getAttribute('data-direction');
      directionInput.value = state.direction;

      if (door) {
        var isLeft = state.direction === 'فتح شمال';
        door.classList.toggle('dir-left', isLeft);
        door.classList.toggle('dir-right', !isLeft);
      }
    }

    function handleFile() {
      var file = fileInput.files && fileInput.files[0];
      if (!file) {
        state.hasFile = false;
        root.classList.remove('epc-has-design');
        if (placeholder) {
          placeholder.hidden = false;
          placeholder.removeAttribute('aria-hidden');
        }
        if (uploadLabel) uploadLabel.classList.remove('has-file');
        if (uploadText) uploadText.textContent = COPY.upload;
        // [hidden] alone isn't enough: a theme-wide "img { display: block }"
        // outranks the UA [hidden] rule, so hide it explicitly too.
        if (previewImg) {
          previewImg.hidden = true;
          previewImg.style.display = 'none';
          previewImg.removeAttribute('src');
        }
        return;
      }

      state.hasFile = true;
      root.classList.add('epc-has-design');
      if (placeholder) {
        placeholder.hidden = true;
        placeholder.setAttribute('aria-hidden', 'true');
      }
      if (uploadLabel) uploadLabel.classList.add('has-file');
      if (uploadText) uploadText.textContent = file.name;

      var reader = new FileReader();
      reader.onload = function (e) {
        if (previewImg) {
          previewImg.src = e.target.result;
          previewImg.hidden = false;
          previewImg.style.display = 'block';
        }
        if (placeholder) {
          placeholder.hidden = true;
          placeholder.setAttribute('aria-hidden', 'true');
        }
      };
      reader.readAsDataURL(file);
    }

    function handleSubmit(e) {
      if (!state.variantId || !state.colorValue) {
        e.preventDefault();
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = COPY.chooseFirst;
        }
        return;
      }
      if (errorEl) errorEl.hidden = true;
      // الفورم بيتبعت عادي (مش fetch) عشان الصورة تترفع كـ
      // line item property صح من غير أي كود إضافي.
    }

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { selectSize(btn); });
    });

    colorButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { selectColor(btn); });
    });

    directionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { selectDirection(btn); });
    });

    if (fileInput) fileInput.addEventListener('change', handleFile);
    if (form) form.addEventListener('submit', handleSubmit);

    if (uploadTrigger && fileInput) {
      uploadTrigger.addEventListener('click', function () {
        fileInput.click();
      });
    }

    if (revealInput && wall) {
      var updateReveal = function () {
        wall.style.setProperty('--reveal', revealInput.value + '%');
      };
      revealInput.addEventListener('input', updateReveal);
      updateReveal();

      // سحب حقيقي باللمس: بنقرر إتجاه الحركة الأول (أفقي = تحريك
      // السلايدر، رأسي = سكرول عادي للصفحة) عشان السحب يشتغل صح
      // من غير ما يمنع المستخدم من عمل Scroll لتحت.
      var drag = null;

      function pctFromClientX(clientX) {
        var rect = wall.getBoundingClientRect();
        if (!rect.width) return parseFloat(revealInput.value) || 0;
        var pct = ((clientX - rect.left) / rect.width) * 100;
        return Math.max(0, Math.min(100, pct));
      }

      function setReveal(pct) {
        revealInput.value = pct;
        updateReveal();
      }

      wall.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        drag = { id: e.pointerId, startX: e.clientX, startY: e.clientY, locked: null };
      }, { passive: true });

      wall.addEventListener('pointermove', function (e) {
        if (!drag || drag.id !== e.pointerId) return;
        var dx = e.clientX - drag.startX;
        var dy = e.clientY - drag.startY;

        if (drag.locked === null) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          drag.locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (drag.locked === 'x') {
            revealInput.focus({ preventScroll: true });
            if (wall.setPointerCapture) {
              try { wall.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
            }
          }
        }

        if (drag.locked === 'x') {
          e.preventDefault();
          setReveal(pctFromClientX(e.clientX));
        }
        // لو الإتجاه رأسي (locked === 'y') منعملش preventDefault خالص،
        // فالصفحة تكمل تعمل Scroll عادي حتى لو الإصبع لسه على الصورة.
      }, { passive: false });

      function endDrag(e) {
        if (!drag || drag.id !== e.pointerId) return;
        if (wall.releasePointerCapture) {
          try { wall.releasePointerCapture(e.pointerId); } catch (err) { /* noop */ }
        }
        drag = null;
      }
      wall.addEventListener('pointerup', endDrag, { passive: true });
      wall.addEventListener('pointercancel', endDrag, { passive: true });
    }

    if (previewToggle && door) {
      previewToggle.addEventListener('click', function () {
        door.classList.toggle('is-open');
      });
    }

    // اختيار أول مقاس ولون بشكل افتراضي زي التصميم
    if (sizeButtons.length) selectSize(sizeButtons[0]);
    if (colorButtons.length) selectColor(colorButtons[0]);

    updateSubmitState();
  }

  document.querySelectorAll('[data-epc]').forEach(initCustomizer);
})();
/* EPC linked visual options v2 */
(function () {
  'use strict';
  var EN = window.PortafotoLang === 'en';

  function enhancePreview(root) {
    var holder = root.querySelector('.epc-door-holder');
    var door = root.querySelector('[data-epc-door]');
    var frame = root.querySelector('[data-epc-frame]');
    var wall = root.querySelector('.epc-wall');
    var reveal = root.querySelector('[data-epc-reveal]');
    var toggle = root.querySelector('[data-epc-preview-toggle]');
    var afterLayer = root.querySelector('[data-epc-after-layer]');
    if (!holder || !door || !frame || !wall) return;

    var choiceBadge = document.createElement('span');
    choiceBadge.className = 'epc-live-choice';
    choiceBadge.setAttribute('aria-live', 'polite');
    (afterLayer || wall).appendChild(choiceBadge);

    var selectedSize = '';
    var selectedColor = '';
    var selectedDirection = 'فتح يمين';

    function updateChoiceBadge() {
      var bits = [];
      if (selectedColor) bits.push((EN ? 'Frame ' : 'فريم ') + selectedColor);
      if (selectedSize) bits.push(selectedSize);
      choiceBadge.textContent = bits.join(' • ');
      frame.setAttribute('aria-label', choiceBadge.textContent || (EN ? 'Frame preview' : 'معاينة البرواز'));
    }

    function applySize(btn) {
      if (!btn) return;
      selectedSize = btn.childNodes[0].textContent.trim();
      var nums = selectedSize.match(/\d+(?:\.\d+)?/g);
      if (nums && nums.length >= 2) {
        var w = parseFloat(nums[0]);
        var h = parseFloat(nums[1]);
        var largest = Math.max(w, h);
        /* Calibrated against the real room photo (portafoto-electrical-room-v2):
           the electrical panel occupies 38.9%–62.7% horizontally and
           20.44%–47.58% vertically of the preview box, i.e. 23.8% wide and
           27.14% tall. Because the preview box is 3:4, a frame's rendered
           height (as a % of box height) = width% / ratio * 0.75, so the
           smallest 40×50 frame needs ~31.5% width to reach ~29.9% height and
           actually cover the panel — the old 24.5% only reached 23% and left
           the panel sticking out top and bottom. Larger sizes then step up
           roughly in proportion to their real height so customers can judge
           which one suits their wall. */
        var widths = largest <= 50 ? 31.5 : largest <= 70 ? 36 : largest <= 90 ? 41 : 46;
        holder.style.setProperty('--epc-holder-width', widths + '%');
        holder.style.setProperty('--epc-holder-ratio', w + ' / ' + h);
        holder.style.setProperty('--epc-holder-center-y', '34.1%');
      }
      holder.classList.remove('is-resizing');
      void holder.offsetWidth;
      holder.classList.add('is-resizing');
      updateChoiceBadge();
    }

    function applyColor(btn) {
      if (!btn) return;
      selectedColor = btn.getAttribute('data-color-label') || '';
      var accentMap = {
        'أسود': '#151311',
        'أبيض': '#f4f1e9',
        'خشبي فاتح': '#c79a61',
        'خشبي غامق': '#4b3020',
        'دهبي': '#b89542',
        'Black': '#151311',
        'White': '#f4f1e9',
        'Light wood': '#c79a61',
        'Dark wood': '#4b3020',
        'Gold': '#b89542'
      };
      var textureMap = {
        'أسود': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-black.png?v=1787848377')",
        'أبيض': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-white.png?v=1787848384')",
        'خشبي فاتح': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-light-wood.png?v=1787848407')",
        'خشبي غامق': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-dark-wood.png?v=1787848394')",
        'دهبي': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-gold.png?v=1787848369')",
        'Black': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-black.png?v=1787848377')",
        'White': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-white.png?v=1787848384')",
        'Light wood': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-light-wood.png?v=1787848407')",
        'Dark wood': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-dark-wood.png?v=1787848394')",
        'Gold': "url('https://cdn.shopify.com/s/files/1/0757/1089/0174/files/electrical-frame-gold.png?v=1787848369')"
      };
      var accent = accentMap[selectedColor] || btn.getAttribute('data-color-value') || '#151311';
      frame.style.setProperty('--frame-accent', accent);
      frame.style.setProperty('--frame-color', accent);
      frame.style.setProperty('--frame-texture', textureMap[selectedColor] || 'none');
      frame.setAttribute('data-frame-tone', selectedColor);
      updateChoiceBadge();
      frame.classList.remove('is-changing');
      void frame.offsetWidth;
      frame.classList.add('is-changing');
    }

    function applyDirection(btn) {
      if (!btn) return;
      selectedDirection = btn.getAttribute('data-direction') || 'فتح يمين';
    }

    root.querySelectorAll('[data-epc-sizes] .epc-option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { applySize(btn); });
    });
    root.querySelectorAll('[data-epc-colors] .epc-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () { applyColor(btn); });
    });
    root.querySelectorAll('.epc-direction-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { applyDirection(btn); });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        window.setTimeout(function () {
          var isOpen = door.classList.contains('is-open');
          if (isOpen && reveal) {
            reveal.value = '100';
            reveal.dispatchEvent(new Event('input', { bubbles: true }));
          }
          toggle.textContent = isOpen ? (EN ? 'Close preview' : 'إغلاق المعاينة') : (EN ? 'Open preview' : 'معاينة الفتح');
        }, 0);
      });
    }

    applySize(root.querySelector('[data-epc-sizes] .epc-option-btn.is-selected'));
    applyColor(root.querySelector('[data-epc-colors] .epc-swatch.is-selected'));
    applyDirection(root.querySelector('.epc-direction-btn.is-selected'));
  }

  document.querySelectorAll('[data-epc]').forEach(enhancePreview);
})();

/* The customer "room photo" upload was removed from the section — the product
   only needs the design upload — so the old initRoomPreview block (and the
   manual placement sliders it revealed) is gone with it. Frame placement is
   now driven entirely by applySize() above, calibrated to the fixed room
   photo. */
